export default () => ({
    team: null,
    index: 0,
    
    getTeam() {
        fetch('/team.json')
            .then((res) => res.json())
            .then((json) => {
                this.team = json
            });
    }

})